export default {
  map_manager : {
  }    
};
  